export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#F6F6F9\"/><g clip-path=\"url(#a)\"><path d=\"M22.56 11.84l-2.553-.967a.4.4 0 00-.287.007l-6.127 2.6v2.927l-1.48-.574.007-2.92 6.28-2.666-2.387-.914h-.026L9.44 11.8a.17.17 0 00-.107.153v7.74c0 .074.04.134.107.16l6.347 2.714a.65.65 0 00.5.006c1.24-.486 6.38-2.766 6.38-2.766V12a.17.17 0 00-.107-.16\" fill=\"#717684\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M8 8h16v16H8z\"/></clipPath></defs>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};